import React, { useState, useEffect } from 'react'
import { Link } from "react-router-dom"
import Pagination from "../components/layout/Pagination";
import { Helmet } from 'react-helmet';

function BlogList() {
  const [blogs, setBlogs] = useState([]);
  const [loading, setLoading] = useState(false)
  const [totalPages, setTotalPages] = useState(0)
  const [pageSize, setPageSize] = useState(3);
  const [currentPage, setCurrentPage] = useState(1);
  const API_URL = process.env.REACT_APP_API_URL;

  // useEffect(() => {
  //   // Ова ја повикува API-то за добивање на блоговите
  //   fetchBlogs();
  // }, []);

  useEffect(() => {
    // Ова ја повикува API-то за добивање на блоговите
    fetchBlogs();
  }, [currentPage]);

  const fetchBlogs = async () => {
    try {
      const response = await fetch(`${API_URL}/blog/getBlogs?pageNumber=${currentPage}&pageSize=${pageSize}`)

      const result = await response.json()
      setBlogs(result.data.blogs)
      setTotalPages(result.data.totalPages)
      setLoading(false)
    }
    catch (error) {
    }
  }

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  return (
    <div className="max-w-7xl mx-auto p-6">
      <Helmet>
        <title>Блог | Совети и информации за моторни масла, авто делови и одржување</title>
        <meta name="description" content="Прочитајте корисни совети, новитети и упатства поврзани со моторни масла, филтри и одржување на автомобилите. Бидете во тек со најдобрите практики за вашето возило." />
        <meta name="keywords" content="блог, моторни уља, авто совети, одржување на возило, филтри за воздух, масло за мотор, auto servis" />
      </Helmet>
      <h1 className="text-4xl font-bold text-center mb-6">Блог</h1>
      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6">
        {blogs.length >= 1 ? (blogs.map(blog => (
          <div key={blog.id} className="bg-white shadow-lg rounded-lg overflow-hidden">
            <img src={blog.imageUrl} alt={blog.title} className="w-full h-48 object-contain" />
            <div className="p-4">
              <h2 className="text-xl font-semibold">{blog.title}</h2>
              <p className="text-gray-600 mt-2">{blog.content.slice(0, 50)}...</p>
              <Link to={`/blog/${blog.id}`} state={blog} className="text-blue-500 mt-4 inline-block">
                Прочитај повеќе
              </Link>
            </div>
          </div>
        )))
          :
          (
            <p>Во моментов нема активни блогови, следете не на нашите социјални мрежи за повеќе новости и поучни текстови.</p>
          )}

      </div>
      {blogs.length > 0 && (
        <><div className='text-center mt-4'>Тековна страна: {currentPage}</div>
          <Pagination
            totalPages={totalPages}
            currentPage={currentPage}
            onPageChange={handlePageChange}
          /></>
      )}
    </div>
  )
}

export default BlogList
